import { Grid, makeStyles } from '@material-ui/core'
import DazzedHeading14 from 'components/common/text/DazzedHeading14'
import DazzedHeading16 from 'components/common/text/DazzedHeading16'
import DazzedHeading18 from 'components/common/text/DazzedHeading18'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import SparkleIcon from '../../icons/SparkleIcon'
import CopilotUtilization from './CopilotUtilization'
import DateFilter from './DateFilter'
import { trackEvent } from 'utils/analyticsUtils'
import TrademarkText from 'components/common/TrademarkText'

const useStyles = makeStyles(() => ({
  root: {
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 15,
    height: 'var(--copilot-header-height)'
  },
  headerItem: {
    marginLeft: 8,
    whiteSpace: 'nowrap'
  },
  headerItemMargined: {
    marginLeft: 30
  },
  // The header has a fixed height: the title row must stay on one line, so the description
  // truncates instead of wrapping and pushing the date filter row under the widgets.
  titleRow: {
    flexWrap: 'nowrap',
    minWidth: 0
  },
  description: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    minWidth: 0
  },
  dateFilterContainer: {
    marginLeft: 5,
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'nowrap'
  }
}))

const CopilotControlHeader = ({
  pastXDays,
  setPastXDays,
  practiceGuidelinesConfiguration,
  isLoadingPracticeGuidelines
}) => {
  const { t } = useTranslation()
  const classes = useStyles()

  const handleSetPastXDays = useCallback(
    updatedPastXDays => {
      trackEvent('Copilot Control - Time range clicked', {
        time: updatedPastXDays
      })
      setPastXDays(updatedPastXDays)
    },
    [setPastXDays]
  )

  return (
    <Grid container item xs={12} sm={12} md={12} lg={12} className={classes.root}>
      <Grid container item direction="column" wrap="nowrap" xs={9} sm={9} md={9} lg={9}>
        <Grid item container alignItems="center" justifyContent="flex-start" className={classes.titleRow}>
          <SparkleIcon />
          <DazzedHeading18 className={classes.headerItem}>
            <TrademarkText text={t('pages.copilotControl.mainPage.title')} />
          </DazzedHeading18>
          <DazzedHeading18 className={classes.headerItem}>|</DazzedHeading18>
          <DazzedHeading16 className={classes.headerItem} semibold>
            {t('pages.copilotControl.mainPage.subtitle')}
          </DazzedHeading16>
          <DazzedHeading14 className={[classes.headerItemMargined, classes.description].join(' ')} regular>
            {t('pages.copilotControl.mainPage.description')}
          </DazzedHeading14>
        </Grid>
        <Grid item>
          <Grid container id="copilot-datefilter" className={classes.dateFilterContainer}>
            <Grid item>
              <DateFilter pastXDays={pastXDays} onChange={handleSetPastXDays} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <CopilotUtilization
        practiceGuidelinesConfiguration={practiceGuidelinesConfiguration}
        isLoadingPracticeGuidelines={isLoadingPracticeGuidelines}
      />
    </Grid>
  )
}

export default CopilotControlHeader
